import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResultadoFilaMasivaErrorDto } from '../../../domain/model/gestiones-masivas/resultado-fila-masiva-error.dto';
import { ExportarErroresMasivosRepository } from '../../../domain/service/gestiones-masivas/exportar-errores-masivos.repository';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GestionesMasivasErroresHttpService implements ExportarErroresMasivosRepository {
  private readonly endpoint = `${environment.backend.baseUrl}/servicios/carga-masiva/gestiones-masivas/errores`;

  constructor(private http: HttpClient) {}

  exportarErrores(errores: ResultadoFilaMasivaErrorDto[]): Observable<Blob> {
    return this.http.post(this.endpoint, errores, {
      responseType: 'blob'
    });
  }
}
